import React, { useState, useEffect } from "react";
import "./holiday.css";

function HolidayModal() {
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    const hasSeenModal = sessionStorage.getItem("hasSeenModal");

    if (!hasSeenModal) {
      setShowModal(true);
    }
  }, []);

  const handleClose = () => {
    setShowModal(false);
    sessionStorage.setItem("hasSeenModal", "true");
  };

  if (!showModal) return null;
  return (
    <div className="modal-backdrop">
      <div className="holiday-modal">
        <h2>Staff Notice</h2>
        <p>
          Arslan is away from November 2nd – 11th. No bookings will be available
          for him during this time.
        </p>
        <button onClick={handleClose}>Got it</button>
      </div>
    </div>
  );
}

export default HolidayModal;
